var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { Button } from '../UI/Button';
import { Card } from '../UI/Card';
import { Input } from '../UI/Input';
import { LoadingSpinner } from '../UI/LoadingSpinner';
import { User, Mail, Lock, AlertCircle } from 'lucide-react';
import { useToast } from '../UI/Toast';
import { getFriendlyErrorMessage } from '../../lib/errorHandler';
var SignupForm = function (_a) {
    var onSwitchToLogin = _a.onSwitchToLogin, onClose = _a.onClose;
    var _b = useState({
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        confirmPassword: '',
        agreeToTerms: false
    }), formData = _b[0], setFormData = _b[1];
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var _d = useState(''), error = _d[0], setError = _d[1];
    var _e = useState('form'), stage = _e[0], setStage = _e[1];
    var _f = useState(0), resendCoolDown = _f[0], setResendCoolDown = _f[1];
    var _g = useState(false), verificationSent = _g[0], setVerificationSent = _g[1];
    var _h = useState(false), autoChecking = _h[0], setAutoChecking = _h[1];
    var _j = useAuth(), signup = _j.signup, loginWithGoogle = _j.loginWithGoogle, resendVerificationEmail = _j.resendVerificationEmail, currentUser = _j.currentUser, emailVerified = _j.emailVerified;
    var _k = useToast(), showError = _k.showError, showSuccess = _k.showSuccess;
    // Derived email domain link
    var emailLink = useMemo(function () {
        var domain = formData.email.split('@')[1] || '';
        if (!domain)
            return null;
        // Common provider shortcuts
        if (domain.includes('gmail'))
            return 'https://mail.google.com';
        if (domain.includes('yahoo'))
            return 'https://mail.yahoo.com';
        if (domain.includes('outlook') || domain.includes('hotmail') || domain.includes('live.'))
            return 'https://outlook.live.com/mail';
        return "https://".concat(domain);
    }, [formData.email]);
    // Poll for verification while on verify stage
    useEffect(function () {
        if (stage !== 'verify' || emailVerified)
            return;
        if (!currentUser)
            return;
        setAutoChecking(true);
        var interval = setInterval(function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, currentUser.reload()];
                    case 1:
                        _b.sent();
                        if (currentUser.emailVerified) {
                            // Trigger state update by reading emailVerified from context effect
                            window.location.href = '/';
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); }, 5000);
        return function () { clearInterval(interval); setAutoChecking(false); };
    }, [stage, emailVerified, currentUser]);
    // Resend cooldown timer
    useEffect(function () {
        if (resendCoolDown <= 0)
            return;
        var t = setTimeout(function () { return setResendCoolDown(function (c) { return c - 1; }); }, 1000);
        return function () { return clearTimeout(t); };
    }, [resendCoolDown]);
    var handleInputChange = function (e) {
        var _a = e.target, name = _a.name, value = _a.value, type = _a.type;
        setFormData(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[name] = type === 'checkbox' ? e.target.checked : value, _a)));
        });
    };
    var validateForm = function () {
        var errors = [];
        if (!formData.firstName.trim()) {
            errors.push('First name is required');
        }
        if (!formData.lastName.trim()) {
            errors.push('Last name is required');
        }
        if (!formData.email.trim()) {
            errors.push('Email is required');
        }
        else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            errors.push('Please enter a valid email address');
        }
        if (!formData.password) {
            errors.push('Password is required');
        }
        else if (formData.password.length < 6) {
            errors.push('Password must be at least 6 characters long');
        }
        else if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(formData.password)) {
            errors.push('Password must contain at least one uppercase letter, one lowercase letter, and one number');
        }
        if (formData.password !== formData.confirmPassword) {
            errors.push('Passwords do not match');
        }
        if (!formData.agreeToTerms) {
            errors.push('Please agree to the Terms of Service and Privacy Policy');
        }
        return errors;
    };
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var validationErrors, errorMsg, displayName, error_1, friendlyMessage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    setError('');
                    validationErrors = validateForm();
                    if (validationErrors.length > 0) {
                        errorMsg = validationErrors[0];
                        setError(errorMsg);
                        showError(errorMsg);
                        return [2 /*return*/];
                    }
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    displayName = "".concat(formData.firstName, " ").concat(formData.lastName).trim();
                    return [4 /*yield*/, signup(formData.email, formData.password, displayName, formData.firstName.trim(), formData.lastName.trim())];
                case 2:
                    _a.sent();
                    setVerificationSent(true);
                    setStage('verify');
                    setResendCoolDown(45); // initial cooldown
                    showSuccess("Account created. Please check your email to verify your address.");
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    friendlyMessage = getFriendlyErrorMessage(error_1, 'auth');
                    setError(friendlyMessage);
                    showError(friendlyMessage);
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleGoogleSignup = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_2, friendlyMessage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setError('');
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, loginWithGoogle()];
                case 2:
                    _a.sent();
                    showSuccess("Welcome to LectureLearn! 🎉 Your Google account is all set up!");
                    if (onClose)
                        onClose();
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _a.sent();
                    friendlyMessage = getFriendlyErrorMessage(error_2, 'auth');
                    setError(friendlyMessage);
                    showError(friendlyMessage);
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    // Removed local getErrorMessage; centralized errorHandler covers these cases.
    if (stage === 'verify') {
        return (_jsxs(Card, __assign({ className: "w-full max-w-md mx-auto overflow-hidden shadow-lg" }, { children: [_jsxs("div", __assign({ className: "bg-gradient-to-r from-blue-600 to-indigo-600 px-6 py-8 text-center" }, { children: [_jsx("div", __assign({ className: "w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3" }, { children: _jsx(Mail, { className: "h-6 w-6 text-white" }) })), _jsx("h2", __assign({ className: "text-2xl font-bold text-white mb-1" }, { children: "Verify your email" })), _jsx("p", __assign({ className: "text-info text-sm" }, { children: "We sent a verification link to" })), _jsx("p", __assign({ className: "text-white font-medium break-all mt-1 text-sm" }, { children: formData.email }))] })), _jsxs("div", __assign({ className: "p-6 space-y-5" }, { children: [emailVerified && (_jsx("div", __assign({ className: "bg-success-muted border border-success/20 text-success px-4 py-3 rounded text-sm" }, { children: "Email verified! Redirecting..." }))), !emailVerified && verificationSent && (_jsx("div", __assign({ className: "bg-info-muted border border-info/20 text-info px-4 py-3 rounded text-sm" }, { children: "Check your inbox and click the link. This page will auto-detect verification." }))), error && (_jsx("div", __assign({ className: "bg-error-muted border border-error/20 text-error px-4 py-3 rounded text-sm" }, { children: error }))), _jsxs("div", __assign({ className: "space-y-3" }, { children: [emailLink && (_jsx(Button, __assign({ asChild: true, className: "w-full" }, { children: _jsx("a", __assign({ href: emailLink, target: "_blank", rel: "noopener noreferrer" }, { children: "Open Email Provider" })) }))), _jsx(Button, __assign({ variant: "outline", className: "w-full", disabled: resendCoolDown > 0 || emailVerified, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                        var e_1;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    _a.trys.push([0, 2, , 3]);
                                                    return [4 /*yield*/, resendVerificationEmail()];
                                                case 1:
                                                    _a.sent();
                                                    setVerificationSent(true);
                                                    setResendCoolDown(60);
                                                    return [3 /*break*/, 3];
                                                case 2:
                                                    e_1 = _a.sent();
                                                    setError((e_1 === null || e_1 === void 0 ? void 0 : e_1.message) || 'Failed to resend email');
                                                    return [3 /*break*/, 3];
                                                case 3: return [2 /*return*/];
                                            }
                                        });
                                    }); } }, { children: resendCoolDown > 0 ? "Resend in ".concat(resendCoolDown, "s") : 'Resend Verification Email' })), _jsx(Button, __assign({ variant: "ghost", className: "w-full text-sm", onClick: function () {
                                        setStage('form');
                                        setError('');
                                    }, disabled: loading }, { children: "Use a different email" })), _jsx("div", __assign({ className: "text-center text-xs text-muted-foreground" }, { children: "This helps us secure your account & provide recovery options." }))] }))] }))] })));
    }
    return (_jsxs(Card, __assign({ className: "w-full max-w-md mx-auto overflow-hidden shadow-lg" }, { children: [_jsxs("div", __assign({ className: "bg-gradient-to-r from-purple-600 to-blue-600 px-6 py-8 text-center" }, { children: [_jsx("div", __assign({ className: "w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3" }, { children: _jsx(User, { className: "h-6 w-6 text-white" }) })), _jsx("h2", __assign({ className: "text-2xl font-bold text-white mb-1" }, { children: "Join LectureLearn" })), _jsx("p", __assign({ className: "text-primary text-sm" }, { children: "Start your AI-powered learning journey" }))] })), _jsxs("div", __assign({ className: "p-6" }, { children: [error && (_jsxs("div", __assign({ className: "bg-error-muted dark:bg-error-muted/20 border border-error/20 dark:border-error rounded-lg p-3 mb-4 flex items-center space-x-2" }, { children: [_jsx(AlertCircle, { className: "h-4 w-4 text-error dark:text-error flex-shrink-0" }), _jsx("p", __assign({ className: "text-sm text-error dark:text-error" }, { children: error }))] }))), _jsxs("form", __assign({ onSubmit: handleSubmit, className: "space-y-3" }, { children: [_jsxs("div", __assign({ className: "grid grid-cols-2 gap-2" }, { children: [_jsx(Input, { type: "text", label: "First Name", icon: _jsx(User, { className: "h-4 w-4" }), name: "firstName", value: formData.firstName, onChange: handleInputChange, placeholder: "First name", required: true, disabled: loading, autoComplete: "given-name" }), _jsx(Input, { type: "text", label: "Last Name", icon: _jsx(User, { className: "h-4 w-4" }), name: "lastName", value: formData.lastName, onChange: handleInputChange, placeholder: "Last name", required: true, disabled: loading, autoComplete: "family-name" })] })), _jsx(Input, { type: "email", label: "Email Address", icon: _jsx(Mail, { className: "h-4 w-4" }), name: "email", value: formData.email, onChange: handleInputChange, placeholder: "Enter your email", required: true, disabled: loading, autoComplete: "email" }), _jsx(Input, { type: "password", label: "Password", icon: _jsx(Lock, { className: "h-4 w-4" }), name: "password", value: formData.password, onChange: handleInputChange, placeholder: "Create password", required: true, disabled: loading, autoComplete: "new-password", minLength: 6 }), _jsx(Input, { type: "password", label: "Confirm Password", icon: _jsx(Lock, { className: "h-4 w-4" }), name: "confirmPassword", value: formData.confirmPassword, onChange: handleInputChange, placeholder: "Confirm password", required: true, disabled: loading, autoComplete: "new-password", minLength: 6 }), _jsxs("div", __assign({ className: "flex items-start space-x-2" }, { children: [_jsx("input", { type: "checkbox", id: "agreeToTerms", name: "agreeToTerms", checked: formData.agreeToTerms, onChange: handleInputChange, className: "mt-1 h-4 w-4 text-info focus:ring-blue-500 border-border rounded", required: true, disabled: loading }), _jsxs("label", __assign({ htmlFor: "agreeToTerms", className: "text-xs text-muted-foreground dark:text-muted-foreground leading-4" }, { children: ["I agree to the", ' ', _jsx("a", __assign({ href: "https://www.lecturelearn.com/terms", target: "_blank", rel: "noopener noreferrer", className: "text-info dark:text-info hover:underline font-medium" }, { children: "Terms of Service" })), ' ', "and", ' ', _jsx("a", __assign({ href: "https://www.lecturelearn.com/privacy", target: "_blank", rel: "noopener noreferrer", className: "text-info dark:text-info hover:underline font-medium" }, { children: "Privacy Policy" }))] }))] })), _jsx(Button, __assign({ type: "submit", disabled: loading, className: "w-full h-10 text-sm font-medium" }, { children: loading ? (_jsxs("div", __assign({ className: "flex items-center justify-center space-x-2" }, { children: [_jsx(LoadingSpinner, { size: "sm" }), _jsx("span", { children: "Creating account..." })] }))) : ('Create Account') }))] })), _jsx("div", __assign({ className: "my-4" }, { children: _jsxs("div", __assign({ className: "relative" }, { children: [_jsx("div", __assign({ className: "absolute inset-0 flex items-center" }, { children: _jsx("div", { className: "w-full border-t border-border dark:border-border" }) })), _jsx("div", __assign({ className: "relative flex justify-center text-sm" }, { children: _jsx("span", __assign({ className: "px-3 bg-white dark:bg-muted text-muted-foreground dark:text-muted-foreground" }, { children: "Or continue with" })) }))] })) })), _jsx(Button, __assign({ onClick: handleGoogleSignup, disabled: loading, variant: "outline", className: "w-full h-11 text-base font-medium" }, { children: _jsxs("div", __assign({ className: "flex items-center justify-center space-x-3" }, { children: [_jsxs("svg", __assign({ className: "w-5 h-5", viewBox: "0 0 24 24" }, { children: [_jsx("path", { fill: "#4285F4", d: "M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" }), _jsx("path", { fill: "#34A853", d: "M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" }), _jsx("path", { fill: "#FBBC05", d: "M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" }), _jsx("path", { fill: "#EA4335", d: "M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" })] })), _jsx("span", { children: "Continue with Google" })] })) })), _jsx("div", __assign({ className: "mt-6 text-center" }, { children: _jsxs("div", __assign({ className: "text-sm text-muted-foreground dark:text-muted-foreground" }, { children: ["Already have an account?", ' ', _jsx("button", __assign({ type: "button", onClick: onSwitchToLogin, className: "text-info dark:text-info hover:underline font-medium", disabled: loading }, { children: "Sign in" }))] })) }))] }))] })));
};
export default SignupForm;
